import React from "react";
import "./App.css";
import { AppRoutes } from "./routes";
import {
  Configuration,
  InteractionType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { MsalAuthenticationResult, MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { Constants } from "./utils/constants";

function App() {
  const configuration: Configuration = {
    auth: {
      clientId: Constants.ClientId,
      redirectUri: `${window.origin}/redirect`,
    },
  };

  const pca = new PublicClientApplication(configuration);

    const authRequest = {
      scopes: ["openid", "profile"],
    };
  
    const ErrorComponent = (error: MsalAuthenticationResult) => {
      return <p>An Error Occurred: {error?.error?.message}</p>;
    };
  
    function LoadingComponent(obj:any) {
      return <p>Authentication in progress...</p>;
    }

  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
        errorComponent={ErrorComponent}
        loadingComponent={LoadingComponent}
      >
        <AppRoutes />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}

export default App;
